import Lottie from "lottie-react";

import animationData from "@app-assets/lotties/loading.json";

export default function LoadingAnimation({ size = 100 }: { size?: number }) {
  return (
    <Lottie
      animationData={animationData}
      autoPlay
      loop
      style={{ width: size, height: size }}
    />
  );
}
